import { AbstractControl } from '@angular/forms';

export function bitlyValidator(control: AbstractControl): {[key: string]: any} | null {
  if (control.value && typeof control.value === 'string' && control.value.includes('bit.ly')) {
    return {bitly: true};
  }

  return null;
}
